// extracted by mini-css-extract-plugin
export default {"popupDiv":"cartpopup_popupDiv__e8zJ8","close":"cartpopup_close__4eA4g","overlay":"cartpopup_overlay__hVftF"};